export function findLicenseByQueryParamId(
  rows: any[],
  licenseId: string | null
): any | undefined {
  if (!licenseId) return undefined;
  return rows.find((row) => row.licenseId === licenseId);
}

// The API uses POC_Pilot (GraphQL enum names can't contain "/"); show users POC/Pilot.
export function formatLicenseTypeLabel(licenseType?: string | null): string {
  return licenseType === "POC_Pilot" ? "POC/Pilot" : licenseType ?? "";
}
